﻿import { mapGetters, mapState } from 'vuex';
import divaLoader from './divaLoader.js';

export default {
    name: 'diva-cancel-order',
    props: ['viewmodel'],
    components: {
        'diva-loader': divaLoader
    },
    data: () => ({
        requestData: {
            dealerCode: '',
            channelType: '',
            orderId: '',
            currentBlock: {}
        },
        showCancelOrderModal: false,
        orderCancelled: false
    }),
    mounted: function() {
        this.requestData = this.viewmodel;
        this.$store.watch((state) => state.digitalvalidation.cancelation.orderCanceled,
            (newState) => {
                this.orderCancelled = newState;
            });
        this.$store.watch((state) => state.digitalvalidation.cancelation.showCancelOrderModal,
            (newState) => {
                this.showCancelOrderModal = newState;
            });

        if (document.getElementById("cancel-order-text-parent").innerText === '') {
            var location = document.getElementById("cancel-order-text").parentNode;

            if (location !== null) {
                location.appendChild(this.$el);
            }
        } else {
            var locationHidden = document.getElementById("cancel-order-text-hidden").parentNode;

            if (locationHidden !== null) {
                locationHidden.appendChild(this.$el);
            }
        }

    },
    methods: {
        cancelWholeOrder: function(event) {
            //event.preventDefault();

            this.$store.dispatch('cancelWholeOrder',
                {
                    'orderId': this.requestData.orderId, 
                    'dealerCode' : this.requestData.dealerCode, 
                    'channelType' :  this.requestData.channelType, 
                    'errorMessage': this.requestData.currentBlock.popUpErrorMessage, 
                    'loaderTitle' :  this.requestData.currentBlock.loaderTitle, 
                    'loaderMessage': this.requestData.currentBlock.loaderMessage
                });
            this.showCancelOrderModal = !this.showCancelOrderModal;
            //this.orderCancelled = true;    
        },
        toggleCancelOrderModal() {
            this.showCancelOrderModal = !this.showCancelOrderModal;
            this.orderCancelled = false;
        },
        closePopup() {         
            this.$store.dispatch('hideModal'); 
        } 
    },
    created: function() {
    },
    computed: {
    }
}